import {BILLING_UPDATE, BILLING_UPDATE_SUCCESS} from "redux/constants/Billing";

export const updateBilling = (creditCardNumber, expireMonth, expireYear, cvc) => ({
  type: BILLING_UPDATE,
  creditCardNumber,
  expireMonth,
  expireYear,
  cvc,
});

export const updateBillingSuccess = (data) => ({
  type: BILLING_UPDATE_SUCCESS,
  data,
});

